import { createContext, useContext } from "react";

import cuid from "cuid";
import PropTypes from "prop-types";

import { BookmarkContextProvider } from "@/users/useBookmarkContent/useBookmarkContent";

const propTypes = {
  children: PropTypes.node,
};

const HomePageContext = createContext({});

const useHomePage = () => {
  return useContext(HomePageContext);
};

const useHomePageId = () => {
  return useHomePage()?.homePageId || null;
};

const HomePageProvider = ({ children }) => {
  const contextData = {
    homePageId: cuid(),
    isHomePage: true,
  };
  return (
    <BookmarkContextProvider>
      <HomePageContext.Provider value={contextData}>
        {children}
      </HomePageContext.Provider>
    </BookmarkContextProvider>
  );
};

HomePageProvider.propTypes = propTypes;

export default useHomePage;
export { HomePageContext, HomePageProvider, useHomePageId };
